// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05d1037d","455":"8f5303f2","977":"d35724d6"}[chunkId] + ".chunk.js";
};